export default __webpack_public_path__ + "static/media/i-vin_sura.57993eb7.svg";